import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  @ViewChild('form') form!: NgForm;
  oobCode = '';
  email = '';
  newPassword = '';
  confirmPassword = '';
  error = '';
  success = '';

  // Password strength checks
  passwordLengthValid = false;
  uppercaseValid = false;
  lowercaseValid = false;
  digitValid = false;
  specialCharValid = false;
  affinityValid = false;
  strengthScore = 0;
  showPassword = false;
  showConfirm = false;
  suggestedPassword: string;

  constructor(
    private route: ActivatedRoute,
    private afAuth: AngularFireAuth,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.oobCode = this.route.snapshot.queryParamMap.get('oobCode') || '';
    if (!this.oobCode) {
      this.error = 'Invalid or missing reset code.';
      return;
    }
    this.afAuth.auth.verifyPasswordResetCode(this.oobCode)
      .then(email => {
        this.email = email;
        this.error = '';
      })
      .catch(() => {
        this.error = 'The reset link is invalid or has expired.';
      });
  }

  generateStrongPassword(length: number = 14, email: string = ''): string {
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    //  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const special = '!@#$%^&*()_+~';
    const allChars = lowercase /* + uppercase */ + digits + special;

    const getRandomChar = (set: string) => {
      const array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      return set[array[0] % set.length];
    };

    const getEmailSubstrings = (email: string): string[] => {
      return email
        .toLowerCase()
        .split(/[@._-]/)
        .filter(part => part.length >= 3);
    };

    const emailParts = getEmailSubstrings(email);
    let attempts = 0;
    const maxAttempts = 10;
    let password = '';

    while (attempts < maxAttempts) {
      attempts++;

      // Ensure one of each required type
      const required = [
        getRandomChar(lowercase),
        // getRandomChar(uppercase),
        getRandomChar(digits),
        getRandomChar(special),
      ];

      const remainingLength = length - required.length;
      const remaining = Array.from({ length: remainingLength }, () => getRandomChar(allChars));
      const combined = [...required, ...remaining];

      password = this.shuffleArray(combined).join('');

      const passwordLower = password.toLowerCase();
      const containsEmailPart = emailParts.some(part => passwordLower.includes(part));
      if (!containsEmailPart) break;
    }

    return password;
  }

  private shuffleArray(array: string[]): string[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  useSuggestedPassword(): void {
    this.newPassword = this.generateStrongPassword(14, this.email);
    this.confirmPassword = this.newPassword;
    this.checkPasswordStrength(this.newPassword);
  }


  checkPasswordStrength(password: string): boolean {
    const email = this.email.toLowerCase();
    const lowerPassword = password.toLowerCase();

    this.passwordLengthValid = password.length >= 12;
    // this.uppercaseValid = /[A-Z]/.test(password);
    this.lowercaseValid = /[a-z]/.test(password);
    this.digitValid = /\d/.test(password);
    this.specialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    this.affinityValid = true;
    const emailParts = email.split(/[@.]/);
    for (const part of emailParts) {
      if (part.length >= 3 && lowerPassword.includes(part)) {
        this.affinityValid = false;
        break;
      }
    }

    let count = 0;
    // if (this.uppercaseValid) count++;
    if (this.lowercaseValid) count++;
    if (this.digitValid) count++;
    if (this.specialCharValid) count++;

    this.strengthScore = count;

    return this.passwordLengthValid && count >= 3 && this.affinityValid;
  }

  get passwordsMatch(): boolean {
    return this.newPassword !== '' && this.newPassword === this.confirmPassword;
  }

  resetPassword(): void {
    this.error = '';
    this.success = '';

    if (!this.passwordsMatch) {
      this.error = 'Passwords do not match.';
      return;
    }

    if (!this.checkPasswordStrength(this.newPassword)) {
      this.error = 'Password must be at least 12 characters, include 3 of 4 character types, and not contain your email.';
      return;
    }

    this.afAuth.auth.confirmPasswordReset(this.oobCode, this.newPassword)
      .then(() => {
        this.success = 'Password saved successfully. You are being redirected to the login page...';
        // Reset the entire form and clear validation
        this.form.resetForm();
        setTimeout(() => {
          this.router.navigate(['/auth/login']);
        }, 2000);
      })
      .catch(err => {
        this.error = 'Error saving password: ' + err.message;
      });
  }
}
